import {
    HorizontalAlignmentOptions,
    RatioOptions,
    TextStyleOptions,
    VerticalAlignmentOptions
} from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsBlogComponentImageWithCopy } from './cms-blog-component-image-with-copy.interface';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../catalog/config/component.config';

export const CMS_BLOG_COMPONENT_IMAGE_WITH_COPY_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsBlogComponentImageWithCopy.ID,
    name: 'Image with copy',
    tags: ['blog'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'component_width',
            type: NICmsContentField.EFieldType.choice,
            title: 'Width',
            default: 'full',
            options: [
                { key: 'full', title: 'Full Width (wrap)' },
                { key: 'fixed', title: 'Fixed Width' }
            ]
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.choice,
            key: 'image_ratio',
            title: 'Image ratio',
            options: RatioOptions,
            default: 'ratio-3-4',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'copy',
            title: 'Copy',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'copy_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Set copy style',
            options: TextStyleOptions,
            default: 'p1'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'url',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'title',
            title: 'Title',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Set title style',
            options: TextStyleOptions,
            default: 'h2'
        },
        <NICmsContentField.IChoiceField>{
            key: 'horizontal_text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Horizontal text alignment',
            options: HorizontalAlignmentOptions,
            default: 'center'
        },
        <NICmsContentField.IChoiceField>{
            key: 'vertical_text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Vertical text alignment',
            options: VerticalAlignmentOptions,
            default: 'middle'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
